window._ = require('lodash');
window.numeral = require('numeral');
window.moment = require('moment');
window.moment.locale('th');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.baseURL = document.head.querySelector('base').href;

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// Add a request interceptor
// axios.interceptors.request.use(function (config) {
//     Pace.restart();
//     return config;
// }, function (error) {
//     return Promise.reject(error);
// });

window.App = {
    baseURL: document.head.querySelector('base').href
};
